import React, { useState } from "react";
import hamburger_icon from "../../assets/icons/hamburger_icon.png";
import paymentDetailsImage from "../../assets/images/paymentDetailsImage.png";
import PaymentDetailsModal from "./Components/PaymentDetailsModal";
import SuperAdminSidebar from "./Components/SuperAdminSidebar";
import SuperAdminSearchBar from "./Components/SuperAdminSearchBar";

const PaymentDetails = () => {
  const [isNavbarVisible, setIsNavbarVisible] = useState(false);
  const [paymentModal, setPaymentModal] = useState(false);

  const toggleNavbar = () => {
    setIsNavbarVisible(!isNavbarVisible);
  };

  return (
    <div>
      <div className="flex items-center justify-center w-full">
        <div
          className="items-center justify-center hidden hamburger"
          onClick={toggleNavbar}
        >
          <img
            src={hamburger_icon}
            alt="hamburger"
            className="object-contain"
          />
        </div>
        <div className="flex items-center justify-center w-full">
          <SuperAdminSearchBar
            categoryName="Payment Details"
            route="/super-admin/payment-details"
          />
        </div>
        <div className="absolute top-0 w-[70%] z-20 bg-white rounded-lg mt-16">
          {isNavbarVisible && <SuperAdminSidebar />}
        </div>
      </div>

      <div className="ml-4 mt-10">
        <p className="text-[18px] font-bold">Payment Detail</p>
      </div>

      <div className="w-full flex flex-col justify-center items-center mt-16">
        <div>
          <img
            src={paymentDetailsImage}
            alt="sms Illustration"
            className="w-52 object-contain"
          />
        </div>
        <p className="text-[18px] font-bold mt-6">
          Start creating Subscription Plans
        </p>
        <p className="text-[#979797] text-[16px] mt-6">
          You can create various Subscription plans to chose from.
        </p>
        <div
          onClick={() => setPaymentModal(true)}
          className="my-6 bg-[#2F80ED] py-3 px-4 text-white rounded-lg cursor-pointer"
        >
          Start Creating
        </div>
      </div>

      {paymentModal ? (
        <PaymentDetailsModal CloseModal={() => setPaymentModal(false)} />
      ) : null}
    </div>
  );
};

export default PaymentDetails;
